var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          _vm.order && _vm.created
            ? _c("order-created", {
                attrs: { order: _vm.order },
                on: { clearData: _vm.clearData }
              })
            : _c(
                "div",
                [
                  _vm.user
                    ? _c("floating-warning", {
                        attrs: {
                          title: "Verifique seu email!",
                          positionY: "bottom",
                          message:
                            "Acesse seu email para confirmar sua conta antes de realizar uma compra.",
                          visible:
                            _vm.user.status === "waiting_email_verification"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "fade", mode: "out-in" } },
                    [
                      _c("select-user", {
                        class: { "passed-on": _vm.address },
                        attrs: { selected: _vm.address },
                        on: {
                          scrollTo: function($event) {
                            return _vm.scrollTo("#to-be")
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "fade", mode: "out-in" } },
                    [
                      _vm.user
                        ? _c("Address", {
                            class: { "passed-on": _vm.address },
                            attrs: { id: "addresses", selected: _vm.address },
                            on: {
                              scrollTo: function($event) {
                                return _vm.scrollTo("#to-be")
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "fade", mode: "out-in" } },
                    [
                      _c("to-be", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.address,
                            expression: "address"
                          }
                        ],
                        class: { "passed-on": _vm.to_be },
                        attrs: { id: "to-be" },
                        on: {
                          scrollTo: function($event) {
                            return _vm.scrollTo("#to-be-selected")
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "fade", mode: "out-in" } },
                    [
                      _vm.to_be === "schedule"
                        ? _c("per-schedule", {
                            attrs: { id: "to-be-selected" },
                            on: {
                              scrollTo: function($event) {
                                return _vm.scrollTo($event)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "fade", mode: "out-in" } },
                    [
                      _vm.to_be === "professional"
                        ? _c("per-professional", {
                            attrs: { id: "to-be-selected" },
                            on: {
                              scrollTo: function($event) {
                                return _vm.scrollTo($event)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "fade", mode: "out-in" } },
                    [
                      _vm.canShowAdditionalInformations()
                        ? _c("additional-informations", {
                            class: { "passed-on": _vm.additional_informations },
                            attrs: { id: "additional-informations" },
                            on: {
                              scrollTo: function($event) {
                                return _vm.scrollTo("#confirmation")
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "fade", mode: "out-in" } },
                    [
                      _vm.canShowConfirmation()
                        ? _c("confirmation", {
                            attrs: { id: "confirmation" },
                            on: {
                              created: function($event) {
                                _vm.created = true
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ec89cbc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec89cbc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Index.vue
// module id = null
// module chunks = 